export default {

  getLocationId: zipCode => `/party/accuweather/locations/v1/postalcodes/US/search?q=${zipCode}`,
  getCurrentConditions: locationId => `/party/accuweather/currentconditions/v1/${locationId}`,
  getSearchResult: () => '/api/v3/10000002/10000002/search',
  getLearnSearchResult: () => '/api/v3/10000002/10001158/search',
  getAreaAddresses: () => 'capture/address/v2/search',
  getNormalizedAddress: () => 'capture/address/v2/format'
};